/* Persists the caller's latest Actuals export, so it survives reloads and reaches the other tabs
 * (through the `storage` event). The write runs as a listener rather than inside the reducer to keep
 * that reducer pure — see listenerMiddleware.
 *
 * Importing this module registers the listener; store.ts does that once at startup.
 */
import { isAnyOf } from '@reduxjs/toolkit';
import { eLocalStorageKeys } from 'src/constants/generic-constants';
import { startAppListening } from 'src/store/listenerMiddleware';
import { remove, save } from 'src/utils/local-storage';
import { actualsExportCleared, actualsExportTracked } from './actualsExportSlice';

startAppListening({
  // A state synced from another tab is already stored, so it is deliberately not matched here.
  matcher: isAnyOf(actualsExportTracked, actualsExportCleared),
  effect: (_action, listenerApi) => {
    const state = listenerApi.getState().actualsExportStore;
    if (state.exportId === null) {
      remove(eLocalStorageKeys.ActualsExport);
      return;
    }
    save(eLocalStorageKeys.ActualsExport, { ...state });
  }
});
